export default "__VITE_ASSET__y3S8ky9F__"